/**
 * Transporte de uma mensagem num inbox híbrido (`WHATSAPP_HYBRID_COEXISTENCE`).
 *
 * As duas conexões do inbox falam pelo MESMO número, mas não têm as mesmas
 * capacidades: a Cloud API não sabe editar nem apagar para todos; a Evolution
 * sabe. Qual das duas entregou a mensagem é DERIVADO do `idExterno` — a Cloud API
 * devolve `wamid.<base64>` e a Evolution devolve um `key.id` cru. Mesma regra do
 * servidor (`transporte.util.ts`), para que a UI habilite exatamente o que o
 * backend aceita.
 *
 * Reagir e responder NÃO aparecem mais aqui: o servidor passou a escolher o
 * transporte pelo id da mensagem alvo (wamid ⇒ Cloud API, id cru ⇒ Evolution),
 * então as duas ações valem em qualquer mensagem do inbox híbrido.
 */

const PREFIXO_WAMID = 'wamid.';

/** `true` se a mensagem saiu/entrou pela Cloud API. Id ausente ⇒ Evolution. */
export const ehTransporteMeta = (idExterno?: string | null): boolean =>
  !!idExterno?.startsWith(PREFIXO_WAMID);

/**
 * Motivos de bloqueio, em texto de usuário. Toda ação bloqueada na interface
 * precisa dizer por quê (NFR-5) — um botão cinza sem explicação é o bug que esta
 * feature veio consertar.
 */
export const MOTIVOS_BLOQUEIO_TRANSPORTE = {
  /** Editar/apagar-para-todos numa mensagem que saiu pela Cloud API. */
  edicaoTransporteMeta:
    'Esta mensagem foi enviada pela conexão oficial (Cloud API), que não permite editar nem apagar para todos.',
  /** Editar/apagar num inbox exclusivamente oficial. */
  edicaoInboxOficial:
    'A conexão oficial (Cloud API) não permite editar nem apagar mensagens para todos.',
  /**
   * Editar/apagar em Instagram ou Messenger. Não é limitação nossa: a API da
   * Meta não expõe a operação em mensagem já enviada — só o cliente apaga, pelo
   * aplicativo. Mesmo texto que o servidor devolve no 400.
   */
  edicaoInboxMetaSocial:
    'A conexão do Instagram/Messenger não permite apagar nem editar mensagens já enviadas: a API da Meta não expõe essa operação.',
} as const;
